import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DynamicTabsService } from 'src/app/dynamic-tabs.service';
import { RefreshDialogComponent } from 'src/app/dialogs/refresh-dialog/refresh-dialog.component';
import { HomeService } from 'src/app/services/homeservice';
import { IaddnewAssociations } from 'src/app/sidenav/helper';
// import { AddnewsCloseDialogComponent } from 'src/app/dialogs/addnews-close-dialog/addnews-close-dialog.component';

@Component({
  selector: 'app-association-addnew',
  templateUrl: './addnew.component.html',
  styleUrls: ['./addnew.component.css']
})
export class AddnewComponent implements OnInit {
  @Output() openDetailTab = new EventEmitter();
  @Input() id: number = 0;
  @Input() label: string = '';
  @Input() type: string = '';
  savingData: boolean = false;
  createWebsite: boolean = false;
  addnewdata: IaddnewAssociations = new IaddnewAssociations();
  addnewdata2: IaddnewAssociations = new IaddnewAssociations();
  response: IaddnewAssociations = new IaddnewAssociations();
  constructor(private service: HomeService,
    private dynamicTabService: DynamicTabsService,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef
  ) {
    // console.log(this.createWebsite);
  }

  ngOnInit(): void {
    this.dynamicTabService.saveObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.routerLink == 'AssnAddNew')
        this.save();
    })

    this.dynamicTabService.refreshObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.routerLink == 'AssnAddNew' && (this.addnewdata.accountID == undefined && !this.addnewdata.accountID ))
        this.refresh();
    })
    //closeTab
    this.dynamicTabService.closeObv.subscribe(value => {
      if (value && this.dynamicTabService.closableTab && this.dynamicTabService.closableTab.routerLink == 'AssnAddNew' && sessionStorage.getItem("closeBtn") == "true")
        this.closeTab();
    })

  }
  openAssociationDetails(addnewdata: any) {
    this.openDetailTab.emit({ id: addnewdata.accountID, label: addnewdata.name + '-Account', type: 'association' });
    return true;
  }

  onClickSave(){
    sessionStorage.setItem('saveBtn', 'true');
    this.save();

  }

  save() {
    if (sessionStorage.getItem('saveBtn') == 'true' && (this.addnewdata.accountID == undefined && !this.addnewdata.accountID ) && this.dynamicTabService.selectedTabData.id == -7) {
      if (this.addnewdata.name != null) {
        sessionStorage.setItem('saveBtn', 'false');
        this.service.getAddnewAssociations(this.addnewdata).subscribe((res: IaddnewAssociations) => {
          this.response = res;
          const newId = res.id;
          this.addnewdata.accountID =this.response.accountID;
          // console.log('new id : $(newId)')
          const i = -(this.response.accountID);
          sessionStorage.setItem('saveBtn', 'false');
          const currentTablabel = this.dynamicTabService.selectedTabData.label;
          // if (this.dynamicTabService.tabs.find(t => t.label == currentTablabel)?.id)
            this.dynamicTabService.tabs.find(t => t.label == currentTablabel)!.id = i;
          if (this.openAssociationDetails(this.response)) {
            this.savingData = true;
            if (this.dynamicTabService?.closableTab?.closable == true)
              // this.dynamicTabService.closeTab(this.dynamicTabService.closableTab);
              this.dynamicTabService.removeTab(this.dynamicTabService.closableTab)
            else {
              var cTab = this.dynamicTabService.tabs.find(t => t.label == currentTablabel);
              if (cTab)
                this.dynamicTabService.removeTab(cTab);
            }
            // console.log(res);
          }
        })


      }
      //  else{
      //   this.dynamicTabService.closeTab(this.dynamicTabService.closableTab);
      //  }

    }
    setTimeout(() => {
      //After data is saved,set savingdata back to false to hide the spinner
      this.savingData = false;
    }, 2000);


  }

  closeTab() {
    // var c = this.dynamicTabService.tabs.find(t => t.id == this.dynamicTabService.closeTabId);
    // if (c)
    //   c.isActive = true;
    if (sessionStorage.getItem("closeBtn") == "true" &&  (this.addnewdata.accountID == undefined && !this.addnewdata.accountID )) {
      this.dynamicTabService.tabs.filter(tab => tab.isActive = false);
      this.dynamicTabService.closableTab.isActive = true;
      this.dynamicTabService.selectedTabData=this.dynamicTabService.closableTab;
      const dialogRef = this.dialog.open(RefreshDialogComponent, {
        data: { message: 'closing?Closing' },
      });
      if (dialogRef.afterOpened())
        sessionStorage.setItem('closeBtn', 'false');
      const i = sessionStorage.getItem('closeBtn');
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'save') {
          sessionStorage.setItem('saveBtn', 'true');
          this.save();

        }
        else if (result === 'discard') {
          this.dynamicTabService.closeTab(this.dynamicTabService.closableTab);
          sessionStorage.setItem('closeBtn', 'false')
        }
      });
    }
  }

  refresh() {
    if (sessionStorage.getItem('refreshBtn') == 'true' && this.dynamicTabService.selectedTabData.id == -7) {
      if (Object.keys(this.addnewdata).length > 0) {
        const dialogRef = this.dialog.open(RefreshDialogComponent, {
          data: { message: 'refreshing?Refreshing' },
        });
        if (dialogRef.afterOpened())
          sessionStorage.setItem('refreshBtn', 'false')
        dialogRef.afterClosed().subscribe(result => {
          if (result === 'save') {
            sessionStorage.setItem('saveBtn', 'true');
            this.save();
            sessionStorage.setItem('refreshBtn', 'false');
          }
          else if (result === 'discard') {
            this.addnewdata = new IaddnewAssociations();
            this.response = new IaddnewAssociations();
            this.cdRef.detectChanges();
            sessionStorage.setItem('refreshBtn', 'false');
            // console.log("Associations addnew refreshed after changes in screen");
          }
        });
      }
      else {
        this.savingData = true;
        this.addnewdata = new IaddnewAssociations();
        this.response = new IaddnewAssociations();
        this.cdRef.detectChanges();
        sessionStorage.setItem('refreshBtn', 'false');
        // console.log("Associations addnew refreshed");
        setTimeout(() => {
          this.savingData = false;
        }, 2000);
      }

    }


  }
  func() {
    // console.log(this.createWebsite);
  }


}

